/* eslint-disable fp/no-mutating-methods */
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Typography } from '@mui/material'

import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import useSession from 'src/authentication/hooks/use-session'
import {
  QuizFinalResults,
  QuizQuestionSelection,
  quizFinalResultsChanged,
  quizRestarted,
  selectCurrentQuizSelections,
  selectQuiz,
  selectQuizFinalResults,
  selectQuizSessionID,
  selectSessionByID,
} from '../live.slice'

let calculateResults = (submission: QuizQuestionSelection[]) =>
  axios
    .post<QuizFinalResults>(
      '/api/v2/live-class/quiz/result/calculate',
      submission,
    )
    .then(({ data }) => data)

let addQuizResults = (results: {
  _id?: string
  userId: string
  quizId: string
  score: number
  result: 'pass' | 'fail'
}): Promise<void> => axios.post('/api/v2/live-class/quiz/result/add', results)

export default () => {
  let navigate = useNavigate()
  let dispatch = useAppDispatch()
  let session = useSession()
  let selections = useAppSelector(selectCurrentQuizSelections)
  let finalResults = useAppSelector(selectQuizFinalResults)
  let sessionID = useAppSelector(selectQuizSessionID)
  let { sessionID: liveSessionID } = useParams()
  let liveSession = useAppSelector(selectSessionByID(liveSessionID ?? ''))
  let quiz = useAppSelector(selectQuiz)

  useEffect(() => {
    if (finalResults && session?.userId) {
      axios
        .post('/api/v2/classroom/quiz/event', {
          QuizEvent: {
            sessionId: sessionID,
            userId: session?.userId ?? '',
            quizId: quiz.id,
            status: finalResults?.isPassing ? 'passed' : 'failed',
          },
        })
        .then(() =>
          addQuizResults({
            result: finalResults?.isPassing ? 'pass' : 'fail',
            userId: session?.userId ?? '',
            quizId: quiz.id,
            score: finalResults?.score ?? 0.0,
          }),
        )
    }
  }, [finalResults, session])

  useEffect(() => {
    calculateResults(selections).then((data) => {
      dispatch(quizFinalResultsChanged(data))
    })
  }, [])

  return (
    <div className="text-center p-4">
      {finalResults && (
        <Typography variant="h4">Score: {finalResults?.score}</Typography>
      )}
      {finalResults.isPassing ? (
        <>
          <Typography>Congratulations, you passed!</Typography>
          <Button
            className="mt-4"
            color="primary"
            variant="contained"
            onClick={() => {
              navigate(`/live/survey/${liveSession?.classQuizID}`)
            }}
          >
            Continue to CE
          </Button>
        </>
      ) : (
        <>
          <Typography>
            Oops, you did not score high enough to obtain a CE, please try again
          </Typography>
          <Button
            className="mt-4"
            color="primary"
            variant="contained"
            onClick={() => dispatch(quizRestarted())}
          >
            Try Again
          </Button>
        </>
      )}
    </div>
  )
}
